import accessLevelsMap from "../../../../lib/access/accessLevelsMap";
import getAccessLevel from "../../../../lib/access/getAccessLevel";
import { NOTIFICATION_TYPES } from "../../../../lib/getStockPageSectionFromNotificationType";
import { getUserData } from "../login/selector";
import hasPermissionRedux from "./utils/hasPermissionRedux";

export const PLAN_PERMISSIONS_NAMES = {
  SIGNALS_AND_SCENARIOS: "plans.signals_and_scenarios",
  LONG_TERM_SIGNALS: "plans.long_term_signals",
  STOCK_TAGS: "plans.stock_tags",
  NOTICES: "plans.notices",
  COMMENTS_AND_ANALYSES: "plans.comments_and_analyses",
  FOLLOW: "plans.follow",
  FUNDAMENTAL_ANALYSES: "plans.fundamental_analyses",
  MORNING_STOCK_BRIEFS: "plans.morning_stock_briefs",
  RECOMMENDATIONS: "plans.stock_messages",
  VIDEO_ANALYSES: "plans.video_analyses",
  PRICE_ALERTS: "plans.price_alerts",
  ALERTED_STOCKS: "plans.alerted_stocks",
  PORTFOLIO: "plans.portfolio",
  TRADING_VIEW_CHART: "plans.trading_view_chart",
  SQUABER_TEAM_COMMENT: "plans.squaber_team_comment",
  SUPPLY_DEMAND_STRATEGY: "plans.supply_demand_strategy",
  TECHNICAL_MANUAL_STRATEGY: "plans.technical_manual_strategy",
  SID_MANUAL_STRATEGY: "plans.sid_manual_strategy",
  FINANCIAL_AND_TECHNICAL_MANUAL_STRATEGY:
    "plans.financial_and_technical_manual_strategy",
  CFD_MANUAL_STRATEGY: "plans.cfd_manual_strategy",
  DONCHAIN_H4: "plans.donchain_h4",
  TREND_STRATEGY: "plans.trend_strategy",
  SAXO_BANK_DISCOUNT: "plans.saxo_bank_discount",
  ALIOR_BANK_DISCOUNT: "plans.alior_bank_discount",
  OTHER_DISCOUNTS: "plans.other_discounts",
  COMPANY_ANALYSIS_REQUESTS: "plans.company_analysis_requests",
  WEBINAR_RECORDINGS: "plans.webinar_recordings",
  PREMIUM_EDUCATION: "plans.premium_education",
  MEDIA_MONITOR: "plans.media_monitor",
  WEBINAR: "plans.webinar",
  EDUCATION_EVENT: "plans.education_event",
  SPECIAL_OFFER: "plans.special_offer",
  THIRD_PARTY_OFFERING: "plans.third_party_offering",
  CSV_DATA_VIEW: "plans.csv_data_view",
  FREEMIUM_STOCK_TAGS: "plans.freemium_stock_tags",
  FREEMIUM_STOCK_ANALYSIS: "plans.freemium_stock_analysis",
  FREEMIUM_PRICE_ALERTS: "plans.freemium_price_alerts",
  FREEMIUM_EDUCATION: "plans.freemium_education",
  FREEMIUM_MEDIA_MONITOR: "plans.freemium_media_monitor",
  FREEMIUM_CSV_DATA: "plans.freemium_csv_data",
  ANONYMOUS_STOCK_TAGS: "plans.anonymous_stock_tags",
  ANONYMOUS_STOCK_ANALYSIS: "plans.anonymous_stock_analysis",
  ANONYMOUS_MEDIA_MONITOR: "plans.anonymous_media_monitor",
  ANONYMOUS_CSV_DATA: "plans.anonymous_csv_data",
  FINANCIAL_INDICATORS: "plans.financial_indicators",
  OPS_OPD_TABLE_PAGE: "plans.ops_opd_table_page",
  HIGHS_AND_LOWS: "plans.highs_and_lows",
  HIGHS_AND_LOWS_INDICATOR_ON_CHARTS:
    "plans.highs_and_lows_indicator_on_charts",
  HIGHS_AND_LOWS_SUMMARY_NOTIFICATIONS:
    "plans.highs_and_lows_summary_notifications",
  INSIDER_ANALYSES: "plans.insider_analyses",
  INSIDER_RECOMMENDATIONS: "plans.insider_recommendations",
  SIGNALS_AND_SCENARIOS_PAID_ONLY: "plans.signals_and_scenarios__paid_only",
  MORNING_STOCK_BRIEFS_FOR_ALL: "plans.morning_stock_briefs__for_all"
};

export const PLANS_PERMISSIONS_ANONYMOUS = [
  PLAN_PERMISSIONS_NAMES.ANONYMOUS_STOCK_TAGS,
  PLAN_PERMISSIONS_NAMES.ANONYMOUS_STOCK_ANALYSIS,
  PLAN_PERMISSIONS_NAMES.ANONYMOUS_MEDIA_MONITOR,
  PLAN_PERMISSIONS_NAMES.ANONYMOUS_CSV_DATA
];

export const PLAN_PERMISSIONS_SECTIONS = {
  PRICE_ALERTS: [PLAN_PERMISSIONS_NAMES.PRICE_ALERTS],
  SIGNALS: [PLAN_PERMISSIONS_NAMES.SIGNALS_AND_SCENARIOS],
  FUNDAMENTAL_ANALYSES: [PLAN_PERMISSIONS_NAMES.FUNDAMENTAL_ANALYSES],
  FINANCIAL_INDICATORS: [PLAN_PERMISSIONS_NAMES.FINANCIAL_INDICATORS],
  ANALYSIS_CATEGORIES: [PLAN_PERMISSIONS_NAMES.DONCHAIN_H4],
  USER_NOTES: [PLAN_PERMISSIONS_NAMES.NOTICES],
  INDEX_COMPONENTS: [], //TODO: Add permission
  SECTION_HISTORY_WITH_STOCK: [PLAN_PERMISSIONS_NAMES.PORTFOLIO],
  SECTION_HISTORY_ALERT_MANAGER: [PLAN_PERMISSIONS_NAMES.PRICE_ALERTS],
  MEDIA_MONITOR: [PLAN_PERMISSIONS_NAMES.MEDIA_MONITOR],
  TEMPLATES_AND_ANALYTICS: [PLAN_PERMISSIONS_NAMES.TRADING_VIEW_CHART],
  PORTFOLIOS: [PLAN_PERMISSIONS_NAMES.PORTFOLIO],
  TRANSACTION_STRATEGY: [
    PLAN_PERMISSIONS_NAMES.TECHNICAL_MANUAL_STRATEGY,
    PLAN_PERMISSIONS_NAMES.SID_MANUAL_STRATEGY,
    PLAN_PERMISSIONS_NAMES.FINANCIAL_AND_TECHNICAL_MANUAL_STRATEGY,
    PLAN_PERMISSIONS_NAMES.TECHNICAL_MANUAL_STRATEGY
  ],
  INSIDER_ANALYSES_AND_RECOMMENDATIONS: [
    PLAN_PERMISSIONS_NAMES.INSIDER_ANALYSES,
    PLAN_PERMISSIONS_NAMES.INSIDER_RECOMMENDATIONS
  ],
  TURTLE_STRATEGY_SUMMARY: [PLAN_PERMISSIONS_NAMES.DONCHAIN_H4],
  TREND_STRATEGY: [PLAN_PERMISSIONS_NAMES.TREND_STRATEGY],
  HIGHS_AND_LOWS: [PLAN_PERMISSIONS_NAMES.HIGHS_AND_LOWS],
  SID_NOTIFICATIONS: [
    PLAN_PERMISSIONS_NAMES.HIGHS_AND_LOWS_INDICATOR_ON_CHARTS,
    PLAN_PERMISSIONS_NAMES.HIGHS_AND_LOWS_SUMMARY_NOTIFICATIONS
  ],
  SUPPLY_DEMAND: [PLAN_PERMISSIONS_NAMES.SUPPLY_DEMAND_STRATEGY]
};

// Key here is notifications_unique_id of transaction strategy.
// Prefixed keys deliberately differ from their plan codenames: the backend
// prefixes notifications_unique_id with the content type on save, so Highs &
// Lows is "transaction_strategy_highs_and_lows" (permission plans.highs_and_lows)
// and Supply/Demand is "transaction_strategy_supply_demand" (permission
// plans.supply_demand_strategy). Donchian keeps the bare "donchain_h4" because
// its row was seeded by a legacy path that bypassed that hook. Do not "fix"
// the Donchian key - it must keep matching the value the API sends.
export const AUTOMATIC_STRATEGY_PERMISSIONS = {
  [NOTIFICATION_TYPES.DONCHAIN_H4]: [PLAN_PERMISSIONS_NAMES.DONCHAIN_H4],
  [NOTIFICATION_TYPES.TRANSACTION_STRATEGY_HIGHS_AND_LOWS]: [
    PLAN_PERMISSIONS_NAMES.HIGHS_AND_LOWS
  ],
  [NOTIFICATION_TYPES.TRANSACTION_STRATEGY_TREND]: [
    PLAN_PERMISSIONS_NAMES.TREND_STRATEGY
  ],
  [NOTIFICATION_TYPES.TRANSACTION_STRATEGY_SUPPLY_DEMAND]: [
    PLAN_PERMISSIONS_NAMES.SUPPLY_DEMAND_STRATEGY
  ]
};

export const PLAN_PERMISSIONS_NOTIFICATIONS = {
  [NOTIFICATION_TYPES.PRICE_ALERTS]: [PLAN_PERMISSIONS_NAMES.PRICE_ALERTS]
};

export const getHasAccess = state => permission => {
  const userData = getUserData(state);

  const accessLevel = getAccessLevel(userData, {});

  switch (permission) {
    case accessLevelsMap.HAS_PREMIUM_ACCESS: {
      return accessLevel === accessLevelsMap.HAS_PREMIUM_ACCESS;
    }

    case accessLevelsMap.NOT_LOGGED_IN: {
      return accessLevel === accessLevelsMap.NOT_LOGGED_IN;
    }
  }
};

export const getCanDisplaySection = state => (
  planPermissionsSections: String[] | String
) => {
  if (Array.isArray(planPermissionsSections)) {
    return getHasPermission(state)(planPermissionsSections);
  }

  if (typeof planPermissionsSections === "string") {
    return getHasPermission(state)([planPermissionsSections]);
  }
};

export const getCanDisplayNotificationType = state => (
  notificationType: String[]
) => {
  const sectionPermissions =
    PLAN_PERMISSIONS_NOTIFICATIONS?.[notificationType] ?? [];

  return getHasPermission(state)(sectionPermissions);
};

export const getHasPermission = state => (permissions = []) => {
  const userData = getUserData(state);

  return hasPermissionRedux({ userData })({ permissions });
};
